import { randomId } from 'javascripts/utils';
import React from 'react';

class CommandOutput {
  // Depth of the command call stack when this message was added.
  depth = 0;

  constructor() {
    this.key = randomId();
  }

  render() {
    return <>Implement in subclass</>;
  }
}

export default CommandOutput;
